/**
 * StickerData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileInfo } from './file_info'
import type { StickerInfo } from './sticker_info'
import type { UserInfo } from './user_info'

/**
 * StickerData
 */
export interface StickerData {
  /** 表情包ID */
  id?: string
  /** 表情包基础信息 */
  info?: StickerInfo
  /** 表情图片信息 */
  image?: FileInfo
  /** 创建用户信息 */
  create_user?: UserInfo
}

/**
 * StickerData Schema
 */
export const StickerDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '表情包ID',
      format: 'string',
      type: 'string',
      label: '表情包ID',
    },
    info: {
      $ref: 'StickerInfo',
      description: '表情包基础信息',
      label: '表情包基础信息',
    },
    image: {
      $ref: 'FileInfo',
      description: '表情图片信息',
      label: '表情图片信息',
    },
    create_user: {
      $ref: 'UserInfo',
      description: '创建用户信息',
      label: '创建用户信息',
    },
  },
  type: 'object',
}
